// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2HoTc","balanceDisclaimer":"posDashboard_balanceDisclaimer__urVXc"};